import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'
import { getUserData } from '@/auth/utils'

export default {
  namespaced: true,
  state: {
    // orders: [
    //   {
    //     id: 4987,
    //     orderId: '0001',
    //     orderDate: '13 June 2022',
    //     userName: 'jank',
    //     userMobile: '0801234500',
    //     totalPrice: 1200,
    //     orderStatus: 'Take Orders',
    //     status: 'Active',
    //   },
    // ],
  },
  getters: {},
  mutations: {},
  actions: {
    fetchOrders(ctx, queryParams) {
      const userData = getUserData()

      return new Promise((resolve, reject) => {
        const body = {
          pagination: {
            total: 0,
            current: 1,
            pageSize:  20000,
          },
          search: {
            customerId: null,
            shopId: userData.shopId,
            orderStatus: [

            ],
            shippingStatus: [

            ],
            createdOnStart: null,
            createdOnEnd: null,
            productName: queryParams.q,
            sku: '',
          },
          sort: {
            predicate: 'created_date',
            reverse: true,
          },
        }

        axios
          .post(`${baseURL}/api/SaleOrder/GetOrderList`, body, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => {
            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'id',
              sortDesc = false,
              // orderName = null,
              // orderCategory = null,
              status = null,
            } = queryParams

            // const queryLowered = q.toLowerCase()
            const filteredData = response.data.data.list

            // const filteredData = ctx.state.orders.filter(
            //   order =>
            //     /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
            //     (order.orderId.toLowerCase().includes(queryLowered) || order.orderDate.toLowerCase().includes(queryLowered) ||
            //     order.userName.toLowerCase().includes(queryLowered) || order.userMobile.toString().toLowerCase().includes(queryLowered) ||
            //     order.totalPrice.toString().toLowerCase().includes(queryLowered) || order.orderStatus.toString().toLowerCase().includes(queryLowered)) &&
            //     order.status === (status || order.status),
            // )

            // const sortedData = filteredData.sort(sortCompare(sortBy))
            // if (sortDesc) sortedData.reverse()

            resolve({
              orders: paginateArray(filteredData, perPage, page),
              total: response.data.data.pagination.total,
            })
          })
          .catch(error => reject(error))
      })
    },
    getOder(ctx, { id }) {
      const userData = getUserData()

      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/SaleOrder/GetOrderById`, {
            params: {
              id,
            },
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getSalesOrderTrackersList(ctx, { id }) {
      const userData = getUserData()

      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/SaleOrder/GetSalesOrderTrackersList`, {
            params: {
              id,
            },
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${userData.token}`,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getLTLCreateOrder(ctx, payload) {
      const userData = getUserData()

      // axios.defaults.headers.common["Authorization"] = "Bearer " + userData.token
      const body = payload
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/SaleOrder/GetLTLCreateOrder`, body,
            {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${userData.token}`,
              },
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getDataPackage(ctx) {
      const token = 'bG9hZGJvYXJkVXNyOjU0MzQ1Mw=='

      axios.defaults.headers.common.Authorization = 'Bearer ' + 'bG9hZGJvYXJkVXNyOjU0MzQ1Mw=='

      return new Promise((resolve, reject) => {
        axios
          .post('https://oms-api.promptsong.co/api/GetDataPackage',
            {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
                Channel: 'MarketPlaceDEWeb',
              },
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    getShippingFee(ctx, payload) {
      const token = 'bG9hZGJvYXJkVXNyOjU0MzQ1Mw=='

      const body = payload
      // axios.defaults.headers.common["Authorization"] = "Bearer " + "bG9hZGJvYXJkVXNyOjU0MzQ1Mw=="


      // https://oms-api.promptsong.co/api/GetLTLRatePrice
// https://uat-oms-api.azurewebsites.net/api/GetLTLRatePrice

      return new Promise((resolve, reject) => {
        axios
          // .post(`https://oms-api.promptsong.co/api/GetLTLRatePrice`, body,
          .post('https://uat-oms-api.azurewebsites.net/api/GetLTLRatePrice', body,
            {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
              },
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    cancelOrder(ctx, { id }) {
      const userData = getUserData()
      const payload = {}
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`

      return new Promise((resolve, reject) => {
        axios
          .put(`${baseURL}/api/SaleOrder/Cancel?orderId=${id}`, payload,
            {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${userData.token}`,
              },
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    withdrawOrder(ctx, { id }) {
      const userData = getUserData()
      const payload = {}
      axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`

      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Payment/SendOMSBankAccountWithdraw?saleOrderId=${id}`, payload,
            {
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${userData.token}`,
              },
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
